/**
 * List of device model ids that are bluetooth devices
 * @constant
 * @default default ['540938247', '72986808818502']
 */
export var bluetoothDevices = ['540938247', '72986808818502'];
/**
 * Checks if device is a bluetooth device
 * @param deviceModelId Model id of device
 * @returns Returns true if device is a bluetooth device
 */
export function isBluetoothDevice(deviceModelId) {
    return bluetoothDevices.includes(deviceModelId);
}
